<template>
   <div>
      <HeaderInnerPage
         id="how-works"
         title="Cartilha para o Ciclista"
         :background="bgPage"
      >
      </HeaderInnerPage>

      <section class="cartilha-warp">
         <b-container>
            <b-row class="mt-0 mt-lg-3" align-h="center">
               <b-col cols="12" md="8" class="bg-secondary p-4 p-md-5 cartilha-body rounded-lg shadow-lg">
                  <h1><em><span style="font-family:Times New Roman,Times,serif">Olá, ciclista!</span></em></h1>

                   <p class="lead">Imaginamos que esteja ansioso para pedalar, mas antes disso, queremos compartilhar algumas dicas com você.</p>

                  <h3>EDUCAÇÃO NO TRÂNSITO</h3><br>

                  <p>A bicicleta é um veículo, assim como qualquer outro. Portanto, respeite as regras de circulação, os semáforos e as sinalizações de trânsito. Lembre-se que o pedestre é o mais vulnerável dos usuários do trânsito, por isso é obrigação de todos cuidar da segurança dele.</p>
                  <p>Você também é responsável pela construção de uma identidade positiva do ciclista. Então não faça malabarismos, não ande em zigue-zague e não pegue carona em outro veículo.</p>



                     <h3>SEGURANÇA</h3><br>

                     <strong><em>Para a sua segurança, é importante lembrar de alguns cuidados na hora da pedalada. São eles:</em></strong>
                  <br>
                  <br>

                  <ul class="list-cartilha">
                     <li>Havendo ciclovia, circule por ela. Na falta dela, ocupe um lugar na faixa que garanta maior visibilidade para o motorista;</li>
                     <li>Ande no mesmo sentido dos outros veículos e nunca na contramão;</li>
                     <li>Mantenha distância segura dos outros veículos e preste atenção às portas para evitar surpresas;</li>
                     <li>Não use o celular, nem fone de ouvido ao pedalar. Evite artifícios que possam distrair você;</li>
                     <li>Olhe sempre à frente, assim você tem uma visão melhor da via e consegue perceber riscos para agir antecipadamente;</li>
                     <li>Preste atenção a tudo que acontece no caminho e estabeleça sempre contato visual com os outros usuários da via;</li>
                     <li>Olhe para os dois lados antes de passar um cruzamento;</li>
                     <li>Sinalize suas intenções fazendo gestos como, por exemplo, esticar o braço em direção à esquerda ou à direita indicando o caminho que irá pegar ou levantar a mão aberta para mostrar que você está parando;</li>
                     <li>Utilize a campainha quando necessário. Avise que você está passando;</li>
                     <li>Utilize os freios dianteiros e traseiros conjuntamente para obter maior eficácia ao frear. Freiecom antecedência e nunca nas curvas;</li>
                     <li>Cuidado com cordões ou partes soltas do vestiário, eles podem enroscar na corrente e causar queda. Evite também levar objetos pendurados no guidão;</li>
                     <li>Dê preferência a roupas claras e use iluminação traseira e dianteira. Fique sempre bem visível;</li>
                     <li>Use sempre o capacete bem preso à cabeça e ajustado adequadamente;</li>
                     <li>Crianças devem andar de bicicleta em parques e locais protegidos do tráfego comum.</li>
                  </ul>



                     <h3>ACESSÓRIOS</h3><br>


                  <strong><em>Alguns acessórios são considerados obrigatórios para as bicicletas de acordo com o Código de Trânsito Brasileiro. Confira quais são eles a seguir.</em></strong>
                  <br>
                  <br>

                  <ul class="list-cartilha">
                     <li> <strong>Sinalizações noturnas reflexivas:</strong> a sinalização dianteira deve ser na cor branca, a traseira na cor vermelha, os pedais e laterais na cor amarela ou branca. Mantenha-as limpas para que possam refletir a luz.</li>
                     <li> <strong>Campainha:</strong> a campainha deve ser de boa qualidade para permitir que os outros usuários identifiquem a bicicleta no trânsito e fiquem atentos.</li>
                     <li> <strong>Espelho retrovisor:</strong> deve ser colocado um espelho retrovisor pelo menos do lado esquerdo.
                        Escolha um acessório de qualidade, que permita a visualização do que acontece atrás do
                        ciclista. O material deste equipamento deve ser de plástico para não oferecer risco.</li>
                  </ul>


                  <p>Se notar a falta de algum desses equipamentos ou qualquer problema de funcionamento na bicicleta alugada, contacte o anfitrião.</p>

                  <p><strong>Além disso, outros itens são recomendados para garantir maior segurança e conforto na pedalada, sendo:</strong></p>

                  <ul class="list-cartilha">
                     <li><strong>Luzes adicionais e reflexivas:</strong>use refletores na bicicleta e no capacete. Atualmente existem luzes de LED que tornam o ciclista e a bicicleta mais visíveis à noite.</li>
                     <li><strong>Para-lama:</strong>o uso de para-lama evita respingos na roupa.</li>
                     <li><strong>Porta-garrafa:</strong>leve sempre água com você e mantenha-se hidratado.</li>
                     <li><strong>Capacete:</strong>apesar de não ser obrigatório, o capacete protege você em caso de queda. Escolha um de boa qualidade.</li>
                     <li><strong>Colete reflexivo:</strong>o colete reflexivo favorece a visualização do ciclista na via, principalmente à noite.</li>
                     <li><strong>Presilhas:</strong>as presilhas servem para prender a barra da calça, evitando que enrosque na corrente.</li>
                     <li><strong>Cadeados, travas e cabos:</strong>é importante usar cadeados, travas e cabos ao estacionar a bicicleta. Isso garante mais segurança e tranquilidade para você.</li>

                  </ul>

                  <!-- <h3>COMO PRENDER A BICICLETA</h3><br />


                  <p><strong>Para prender a bicicleta, siga o passo a passo a seguir:</strong></p>


                  <ol class="list-cartilha">
                     <li>Certifique-se de que o paraciclo em que você vai amarrar a bicicleta esteja bem firme, preso ao chão.</li>
                     <li> Prenda a roda traseira e o quadro junto ao paraciclo.</li>
                     <li> Use um cabo de aço ou trava tipo U-Lock para prender a roda dianteira e o selim, passando por dentro do quadro. Se possível, dê preferências a trava tipo U-Lock, em formato de U, que aumenta muito a segurança da bicicleta por ser mais difícil de abrir que um cabo de aço tradicional.</li>
                     <li> Rodas que possuem sistema de desengate rápido (Quick Release) precisam estar presas. O mesmo acontece com o selim. Ele pode ser retirado e levado com você.</li>
                     <li> Retire da bike os acessórios que podem ser facilmente levados.</li>
                  </ol> -->

                  <h3>MANUTENÇÃO</h3><br>

                  <p>Antes de iniciar seu passeio, confira se a manutenção da bicicleta alugada está em dia. Veja se os freios, correntes e rodas estão funcionando corretamente. Lembrando que é fundamental que todas as partes da bicicleta estejam bem fixadas. Se notar qualquer problema no funcionamento da bicicleta, não hesite em contatar o anfitrião.</p>

                  <br>

                  <p><strong>Agora sim, você está preparado para pedalar pela cidade!</strong></p>


                  <img class="img-fluid" :src="imgCartilha" alt="">

               </b-col>
            </b-row>
         </b-container>
      </section>


      <CallToActionSection
         :bg="bgCallToActionSection"
         class="mt-5"
         title="Quer alugar uma bicicleta?"
         desc="Procure agora mesmo uma bicicleta próximo a você."
         textLink="BUSCAR BICICLETA"
         searchLink

      />

   </div>
</template>

<script>
import bgPage from '@/assets/img/cartilha-ciclista.jpg';
import bgCallToActionSection from '@/assets/img/ajuda-pedale.jpg';
import HeaderInnerPage from "@/components/HeaderInnerPage.vue";
import CallToActionSection from "@/components/CallToActionSection";
import {metaTags} from "@/helpers";
import imgCartilha from "@/assets/img/img-cartilha-ciclista.svg";


export default {
   name: 'Help',
   metaInfo: metaTags(`Cartilha para o Ciclista`),
   components: {
      HeaderInnerPage,
      CallToActionSection
   },
   data() {
      return {
         bgPage,
         imgCartilha,
         bgCallToActionSection
      }
   },
}
</script>

<style lang="scss">



</style>
